// extracted by mini-css-extract-plugin
module.exports = {"filtersCategoryMarker":"FiltersCategoryMarker_filtersCategoryMarker__2nC1K"};